import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { user } from "redux-store/user/user.selectors";
import { useNavigate } from "react-router-dom";
import CareTeamModel from "../lab-result/CareTeamModel";
import PetDetailsModel from "../lab-result/PetDetailsModel";
import { AppDispatch } from "redux-store/store";
import { getUserPets } from "redux-store/pets/pet.slice";
import { pet, petActivityInProcess } from "redux-store/pets/pet.selector";

const ActiveUsersRow = ({ user }: { user: any }) => {
  const dispatch = useDispatch<AppDispatch>();
  const pets = useSelector(pet);
  const loading = useSelector(petActivityInProcess);
  const navigate = useNavigate();
  const [showVetModel, setShowVetModel] = useState(false);
  const [showPetModel, setShowPetModel] = useState(false);
  const [userId, setUserId] = useState(null);

  function toggleShowVetModel() {
    setShowVetModel(true);
    setUserId(user._id);
  }
  function toggleShowPetModel() {
    setShowPetModel(true);
    setUserId(user._id);
  }
  function handlePetModelClose() {
    setShowPetModel(false);
  }
  useEffect(() => {
    if (userId) {
      dispatch(getUserPets(userId));
    }
  }, [userId]);

  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-2">
        <div className="tw-flex-1 tw-cursor-pointer tw-text-xl tw-text-[#000000] tw-font-normal">{user.fullName}</div>
        <div className="tw-flex-1 tw-cursor-pointer tw-text-xl  tw-text-[#000000] tw-font-normal tw-truncate">
          {user.email}
        </div>

        <div className="tw-flex tw-flex-1 tw-gap-2">
          <button
            onClick={() => {
              // navigate(`/admin/users`);
              toggleShowVetModel();
            }}
            className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
          >
            Vet
          </button>

          <button
            onClick={() => {
              // navigate(`/admin/add-pet/${users.user._id}`)
              // navigate(`/admin/users`);
              toggleShowPetModel();
            }}
            className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[blue] tw-py-2 tw-px-8 tw-rounded-md"
          >
            Pet
          </button>
        </div>
      </div>
      <CareTeamModel setShowVetModel={setShowVetModel} showVetModel={showVetModel} userId={userId} showButtons={true} />
      <PetDetailsModel
        handlePetModelClose={handlePetModelClose}
        open={showPetModel}
        pets={pets}
        userId={userId}
        loading={loading}
      />
    </>
  );
};

export default ActiveUsersRow;
